<script lang="ts">
	//UI
	import Login from "./views/Login.svelte";
	import LoginRedirect from "./views/LoginRedirect.svelte";
	import StoreValidation from "./v7/component/Common/StoreValidation.svelte";
	import UserValidation from "./v7/component/Common/UserValidation.svelte";
	import SearchStores from "./v7/views/SearchStores.svelte";
	import EventLogging from "./v7/views/EventLogging.svelte";
	import SearchUser from "./v7/views/SearchUser.svelte";
	import Store from "./v7/views/Store.svelte";
	import User from "./v7/views/User.svelte";
	import HubSetting from "./v7/views/HubSetting.svelte";
	import Earning from "./v7/views/Earning.svelte";
	import ManageStore from "./v7/views/ManageStore.svelte";
	import Revenue from "./v7/views/Revenue.svelte";
	import Dashboard from "./v7/views/Dashboard.svelte";
	import Product from "./v7/views/Product.svelte";
	import RedirectHome from "@hitit/hub/src/views/RedirectHome.svelte";
	import Place from "./v7/views/Place.svelte";
	import OrderDetailLink from './v7/component/Revenue/OrderDetailLink.svelte';
	//Utils
	import Notifications from "@hitit/hub/src/v7/components/common/Alert.svelte";
	import AppLayout from "./v7/layout/AppLayout.svelte";
	import { Router, Route } from "svelte-routing";
	import { token, user, api, store, refreshToken } from "@hitit/hub/src/stores";
	import { selectedUser } from "./v7/stores";

	//Types
	//Props
	//Constants
	//Variables
	$: isLoggedIn = Boolean($token);
	$: isLoaded = Boolean($user);

	//Functions
	async function loadUser() {
		const r = await $api.getUser();
		$user = r.data;
	}

	//Do
	$: if ($token) loadUser();
</script>

<Notifications />

<Router>
	{#if isLoggedIn && isLoaded}
		<AppLayout store={$store}>
			<Route path="/">
				<RedirectHome path="/store" />
			</Route>
			<Route path="/store">
				<SearchStores />
			</Route>
			<Route path="/users">
				<SearchUser />
			</Route>
			<Route path="/hubsetting/*">
				<HubSetting />
			</Route>
			<Route path="/users/:id/*" let:params>
				<UserValidation userId={params.id}>
					{#if $selectedUser}
						<Router>
							<Route path="/">
								<User userId={$selectedUser.id} />
							</Route>
						</Router>
					{/if}
				</UserValidation>
			</Route>
			<Route path="/store/:id/*" let:params>
				<StoreValidation storeId={params.id}>
					{#if $store}
						<Router>
							<Route path="/">
								<ManageStore storeId={$store.id} />
							</Route>
							<Route path="dashboard">
								<Dashboard storeId={$store.id} />
							</Route>
							<Route path="revenue/*">
								<Revenue storeId={$store.id} />
							</Route>
							<Route path="/store">
								<Store storeId={$store.id} />
							</Route>
							<Route path="/product/*">
								<Product storeId={$store.id} />
							</Route>
							<Route path="eventLogging">
								<EventLogging storeId={$store.id} />
							</Route>
							<Route path="/earning/*">
								<Earning storeId={$store.id} />
							</Route>
							<Route path="place">
								<Place storeId={$store.id} />
							</Route>
						</Router>
					{/if}
				</StoreValidation>
			</Route>
			<Route path="/store/orderDetail/:storeId/:orderId" let:params>
				<OrderDetailLink storeId={params.storeId} orderId={params.orderId}/>
			</Route>
		</AppLayout>
	{:else if !isLoggedIn}
		<Route path="*">
			<LoginRedirect refreshToken={$refreshToken} />
		</Route>
		<Route path="/login">
			<Login />
		</Route>
	{/if}
</Router>

<style lang="scss">
</style>
